import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <path d="M18.07,22.38a1,1,0,1,1-1.41,1.42l0,0L8.29,15.26a1,1,0,0,1,0-1.4L16.64,5.3a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41L10.4,14.56l7.67,7.82Z" />
  </React.Fragment>,
  'Chevron'
)
